import { LitElement, css, html } from 'lit';
import { CzLoader } from '../cz-loader/cz-loader.js';
import { CzIcon } from '../cz-icon/cz-icon.js';

/**
 * Represents a custom content loader component.
 * should be used as a basis for loading content based on a url
 * will show the cz-loader component until the content is loaded
 * @extends LitElement
 */
export class CzContentloader extends LitElement {
	static styles = css`
		@layer component {
			:host {
				display: grid;
			}
			:host(:empty){
				aspect-ratio: 1/.5;
			}
			cz-icon {
				margin: auto;
			}
		}
	`;

	#url = false;

	/**
	 * override this method in the class that extends this contentloader
	 * @param {url} url 
	 * @returns promise
	 */
	callBackend = async (url) => {
		let result;
		result = `<p>This is what would get loaded if you don't override the async callBackend method</p>`;
		return result;
	}
	
	render() {
		return html`<slot><cz-icon><cz-loader></cz-loader></cz-icon></slot>`;
	}


	/**
	 * Don't forget to call loadContent method from this function if you override it
	 *
	 * @param {*} changedProperties
	 */
	updated(changedProperties) {
		if (changedProperties) {
			this.innerHTML = '';
			this.loadContent()
				.then((f) => console.log(f))
				.catch((e) => console.log(e));
		}
	}

	async loadContent() {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				if (this.#url) {
					this.callBackend(this.#url).then(result => {
						this.innerHTML = result;
						return resolve('succes!');
					}).catch(() => reject(new Error('Error loading content!')));
				}
			}, 10);
		});
	}
	
	constructor() {
		super();
		this.#url = this.getAttribute('url');
	}
}
